import RouteLoader from './RouteLoader';

export default RouteLoader;
